import React, { useCallback } from 'react';
import cn from 'classnames';
import { useHeaderContext } from '@context';
import PropTypes from 'prop-types';
import { ProductFamilyPropType } from '@propTypes';
import styles from './styles/index.module.scss';

const MenuLink = ({ item, onClick, className }) => {
  const { platformBaseUrl } = useHeaderContext();

  const onItemClick = useCallback(
    e => {
      onClick(e, { level: item.level, type: 'default', destination: item.url });
    },
    [onClick, item],
  );

  const familyClassName = cn({
    [styles.family]: item.level === 0,
  });

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
  return (
    <li className={className}>
      <a
        className={cn(styles.menuLink, familyClassName) }
        href={`${platformBaseUrl}${item.url}`}
        onClick={onItemClick}
      >
        {item.name}
      </a>
    </li>
  );
};

MenuLink.propTypes = {
  item: ProductFamilyPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

MenuLink.defaultProps = {
  className: '',
};

MenuLink.displayName = 'MenuLink';

export default MenuLink;
